import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../application/stores/auth.store';
import Loader from '../components/common/Loaders/Loader';
export const ProtectedClientRoute = () => {
    const { clientToken, isAuthReady, isAuthenticated } = useAuthStore();
    if (!isAuthReady)
        return _jsx(Loader, { fullBlack: true });
    if (!clientToken && !isAuthenticated)
        return _jsx(Navigate, { to: "/login" });
    return _jsx(Outlet, {});
};
